<template>
  <v-dialog
    v-model="dialog"
    :max-width="!is_regular_player_or_sales_representative ? 1300 : 1200"
    persistent
  >
    <v-card>
      <div class="d-flex align-center justify-space-between px-6 py-4">
        <h3>
          {{ master_agent_name + " — " + master_agent_sub_agent_title + " List" }}
        </h3>
        <v-btn icon @click="close_master_agent_dialog()">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </div>

      <v-divider></v-divider>

      <div class="d-flex justify-end px-6 py-4">
        <div class="search-wrapper">
          <v-text-field
            ref="search"
            v-model="search"
            placeholder="Search"
            single-line
            hide-details="auto"
            :disabled="loading"
            clearable
            outlined
            dense
          >
          </v-text-field>
        </div>
      </div>

      <v-divider></v-divider>

      <v-data-table
        v-if="!is_regular_player_or_sales_representative"
        :headers="table_headers"
        :items="master_agent_sub_agent"
        :items-per-page="items_per_page"
        :search="search"
        :loading="loading"
        loading-text="Loading, please wait a moment"
        :sort-by.sync="sort_by"
        :sort-desc.sync="sort_desc"
      >
        <template v-slot:[`item.sales_supervisor_count`]="{ item }">
          <a
            v-if="item.sales_supervisor_count != '0'"
            href="#"
            style="text-decoration: none"
            @click.prevent="get_sales_managers_sales_supervisor(item.id, item.name)"
          >
            {{ "View (" + item.sales_supervisor_count + ")" }}
          </a>
          <span v-else>-</span>
        </template>

        <template v-slot:[`item.sales_representative_count`]="{ item }">
          <a
            v-if="item.sales_representative_count != '0'"
            href="#"
            style="text-decoration: none"
            @click.prevent="get_sales_managers_sales_representative(item.id, item.name)"
          >
            {{ "View (" + item.sales_representative_count + ")" }}
          </a>
          <span v-else>-</span>
        </template>

        <template v-slot:[`item.regular_player_count`]="{ item }">
          <a
            v-if="item.regular_player_count != '0'"
            href="#"
            style="text-decoration: none"
            @click.prevent="get_sales_managers_regular_player(item.id, item.name)"
          >
            {{ "View (" + item.regular_player_count + ")" }}
          </a>
          <span v-else>-</span>
        </template>

        <template v-slot:[`item.name`]="{ item }">
          {{ item.name }}
        </template>

        <template v-slot:[`item.mobile_number`]="{ item }">
          {{ "+63" + item.mobile_number }}
        </template>

        <template v-slot:[`item.commission`]="{ item }">
          {{ item.commission }}%
        </template>

        <template v-slot:[`item.sub_commission`]="{ item }">
          <span>{{ item.sub_commission }}%</span>
        </template>

        <template v-slot:[`item.wallet`]="{ item }">
          {{ "PHP " + money_format(parseFloat(item.wallet)) }}
        </template>
      </v-data-table>

      <v-data-table
        v-else
        :headers="regular_player_table_headers"
        :items="master_agent_sub_agent"
        :items-per-page="items_per_page"
        :search="search"
        :loading="loading"
        loading-text="Loading, please wait a moment"
        :sort-by.sync="sort_by"
        :sort-desc.sync="sort_desc"
      >
        <template v-slot:[`item.name`]="{ item }">
          {{ item.name }}
        </template>

        <template v-slot:[`item.mobile_number`]="{ item }">
          {{ "+63" + item.mobile_number }}
        </template>

        <template v-slot:[`item.betting`]="{ item }">
          <v-chip
            small
            :class="
              item.betting == 'Enabled'
                ? 'green lighten-5 green--text'
                : 'red lighten-5 red--text'
            "
          >
            {{ item.betting }}
          </v-chip>
        </template>

        <template v-slot:[`item.cashin`]="{ item }">
          <v-chip
            small
            :class="
              item.cashin == 'Enabled'
                ? 'green lighten-5 green--text'
                : 'red lighten-5 red--text'
            "
          >
            {{ item.cashin }}
          </v-chip>
        </template>

        <template v-slot:[`item.cashout`]="{ item }">
          <v-chip
            small
            :class="
              item.cashout == 'Enabled'
                ? 'green lighten-5 green--text'
                : 'red lighten-5 red--text'
            "
          >
            {{ item.cashout }}
          </v-chip>
        </template>

        <template v-slot:[`item.is_active`]="{ item }">
          <v-chip
            small
            :class="
              item.is_active == 'Active'
                ? 'green lighten-5 green--text'
                : 'red lighten-5 red--text'
            "
          >
            {{ item.is_active }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card>

    <SalesManagerSubAgents
      v-if="sales_manager_dialog"
      :sales_manager_sub_agent_title="sales_manager_sub_agent_title"
      :sales_manager_id="sales_manager_id"
      :sales_manager_name="sales_manager_name"
      @close_sales_manager_dialog="close_sales_manager_dialog"
    />
  </v-dialog>
</template>

<script>
import axios from "axios";
import SalesManagerSubAgents from "@/components/agents/SalesManagerSubAgents.vue";

export default {
  data: () => ({
    table_headers: [
      { text: "Name", value: "name", class: "text-uppercase" },
      {
        text: "SS",
        value: "sales_supervisor_count",
        class: "text-uppercase",
      },
      {
        text: "SR",
        value: "sales_representative_count",
        class: "text-uppercase",
      },
      {
        text: "RP",
        value: "regular_player_count",
        class: "text-uppercase",
      },
      { text: "Mobile Number", value: "mobile_number", class: "text-uppercase" },
      {
        text: "Commission",
        value: "commission",
        class: "text-uppercase",
        align: "right",
      },
      {
        text: "Sub Commission",
        value: "sub_commission",
        class: "text-uppercase",
        align: "right",
      },
      { text: "Wallet", value: "wallet", class: "text-uppercase", align: "right" },
    ],
    regular_player_table_headers: [
      { text: "Name", value: "name", class: "text-uppercase" },
      { text: "Mobile Number", value: "mobile_number", class: "text-uppercase" },
      { text: "Betting", value: "betting", class: "text-uppercase" },
      { text: "Cash In", value: "cashin", class: "text-uppercase" },
      { text: "Cash Out", value: "cashout", class: "text-uppercase" },
      { text: "Status", value: "is_active", class: "text-uppercase" },
    ],
    master_agent_sub_agent: [],
    sales_manager_sub_agent: [],
    sales_manager_sub_agent_title: null,
    sales_manager_id: 0,
    sales_manager_name: null,
    sales_manager_dialog: false,
    loading: false,
    search: null,
    items_per_page: 5,
    sort_by: "name",
    sort_desc: true,
  }),

  mounted() {
    if (this.master_agent_sub_agent_title == "Regular Player") {
      this.get_master_agents_regular_player();
    } else {
      this.get_master_agents_sales_manager();
    }
  },

  props: {
    master_agent_sub_agent_title: String,
    master_agent_id: String,
    master_agent_name: String,
  },

  name: "MasterAgentSubAgents",
  components: { SalesManagerSubAgents },
  methods: {
    async get_master_agents_regular_player() {
      let url = process.env.VUE_APP_API_URL;
      let token = localStorage.getItem("userToken");

      this.loading = true;

      await axios
        .get(url + "agents/master_agents_regular_player", {
          params: { id: this.master_agent_id },
          headers: { Authorization: `Bearer ` + token },
        })
        .then((res) => {
          this.master_agent_sub_agent = res.data.records;
        });

      this.loading = false;
    },
    async get_master_agents_sales_manager() {
      let url = process.env.VUE_APP_API_URL;
      let token = localStorage.getItem("userToken");

      this.loading = true;

      await axios
        .get(url + "agents/master_agents_sales_manager", {
          params: { id: this.master_agent_id },
          headers: { Authorization: `Bearer ` + token },
        })
        .then((res) => {
          this.master_agent_sub_agent = res.data.records;
        });

      this.loading = false;
    },

    // =============================

    get_sales_managers_sales_supervisor(id, name) {
      this.sales_manager_sub_agent_title = "Sales Supervisor";
      this.sales_manager_id = id;
      this.sales_manager_name = name;
      this.sales_manager_dialog = true;
    },
    get_sales_managers_sales_representative(id, name) {
      this.sales_manager_sub_agent_title = "Sales Representative";
      this.sales_manager_id = id;
      this.sales_manager_name = name;
      this.sales_manager_dialog = true;
    },
    get_sales_managers_regular_player(id, name) {
      this.sales_manager_sub_agent_title = "Regular Player";
      this.sales_manager_id = id;
      this.sales_manager_name = name;
      this.sales_manager_dialog = true;
    },

    money_format(val) {
      return val.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    close_master_agent_dialog() {
      this.$emit("close_master_agent_dialog", false);
    },
    close_sales_manager_dialog() {
      this.sales_manager_dialog = false;
      this.sales_manager_sub_agent = [];
    },
  },
  computed: {
    dialog: {
      get: function () {
        return true;
      },
      set: function () {
        this.close_master_agent_dialog();
      },
    },
    is_regular_player_or_sales_representative() {
      if (
        this.master_agent_sub_agent_title == "Regular Player" ||
        this.master_agent_sub_agent_title == "Sales Representative"
      ) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style scoped>
.search-wrapper {
  display: inline-block;
}
.search {
  width: 400px;
}

@media (max-width: 768px) {
  .search-wrapper {
    width: 100% !important;
    display: block !important;
  }
  .search {
    width: 100% !important;
  }
}
</style>
